export default __webpack_public_path__ + "static/media/1600.cd86aa6a.png";